import React, { Component } from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class SelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: ""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(selectedOption) {
    console.log(selectedOption);
    if (selectedOption) {
      if (this.props.multi) {
        this.props.input.onChange(selectedOption);
      } else {
        this.props.input.onChange(selectedOption);
      }
    } else {
      this.props.input.onChange("");
    }
  }

  render() {
    return (
      <Select
        name={this.props.input.name}
        valueKey={this.props.valueKey}
        labelKey={this.props.labelKey}
        value={this.props.input.value}
        onChange={this.handleChange}
        options={this.props.options}
        placeholder={this.props.placeholder}
        multi={this.props.multi}
        disabled={this.props.disabled}
      />
    );
  }
}

export default SelectDropdown;



// WEBPACK FOOTER //
// ./src/system/fields/SelectDropdown/index.jsx